"use client";

import { useAxiosToken } from "@/hooks/useAxiosToken";

const AxiosTokenInitializer: React.FC = () => {
  // Este hook automaticamente sincroniza o token com o axios
  useAxiosToken();

  // Este componente não renderiza nada
  return null;
};

export default AxiosTokenInitializer;
